import { render, staticRenderFns } from "./Sso.vue?vue&type=template&id=59f5205c"
import script from "./Sso.vue?vue&type=script&lang=js"
export * from "./Sso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports